import actionCreatorFactory from 'typescript-fsa';
import { GenActionFactoryName } from 'shared/helpers/redux-helpers';
import { ILicence, IModule } from 'shared/api/api';
import { LOAD_ALL, LOAD_SITE_MODULES } from './types';

const actionCreator = actionCreatorFactory(GenActionFactoryName('licences'));

export const loadSiteModules = actionCreator.async<{}, IModule[]>(LOAD_SITE_MODULES);
export const loadAll = actionCreator.async<{}, ILicence[]>(LOAD_ALL);
